export default {
  getSubQuestion: (state) => state.subQuestion,
};
